var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-bar rounded shadowed white",class:_vm.notificationTypeClass},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.notificationIcon))]),_c('p',[_vm._v(_vm._s(_vm.notification.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }